module.exports = "/app/user/img/GOLDEN.5348d239.png";